// src/components/FAQSection.jsx - Panel Acordeón de Preguntas Frecuentes English EOH
import React, { useState } from 'react';

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "🔑 ¿Cómo ingreso por primera vez a la plataforma?",
      a: "Para ingresar no necesitas correos ni crear cuentas complejas. Haz clic en '🔑 Iniciar Sesión / Registro' e ingresa tus datos institucionales:\n• Usuario ID: EOH-[Tu Grupo]-[4Dígitos] (ej: EOH-601-1234).\n• Contraseña: Tu fecha de nacimiento completa YYYYMMDD (ej: 20130514 si naciste el 14 de mayo de 2013)."
    },
    {
      q: "📝 ¿Qué hago si se me olvida mi ID o mi fecha de nacimiento?",
      a: "¡No te preocupes! Consulta directamente con tu profesor titular Lic. Didier Antonio Alvarez Ramos en clase para que verifique tu ID y datos en el Panel Maestro de Administración."
    },
    {
      q: "🏆 ¿Cómo gano Puntos XP y subo en el ranking de la clase?",
      a: "Cada vez que completas un reto en las 12 Fases Mágicas, resuelves un Taller de 20 Ejercicios (+10 XP por acierto) o presentas un Simulacro ICFES, la plataforma suma automáticamente tus Puntos XP en tiempo real."
    },
    {
      q: "📡 ¿El Profe Didier puede ver mis notas y mis avances?",
      a: "¡Sí! Todo lo que resuelves en la plataforma se guarda automáticamente en la nube de Firebase Firestore. El Profesor Didier puede ver tus aciertos, tu puntaje porcentual y tus Puntos XP desde su Panel Maestro por grupo (601, 602, 603, 701, 702, 703, 901, 902, 903)."
    },
    {
      q: "📱 ¿Puedo usar English EOH desde mi celular o tablet?",
      a: "¡Totalmente! La plataforma es 100% responsiva y adaptable. Puedes practicar desde tu teléfono celular, tablet o computador conectado a internet ingresando a https://english-eoh.vercel.app."
    },
    {
      q: "📖 ¿Cómo funciona el Diccionario Inteligente y los audios en inglés?",
      a: "En la pestaña '📖 Diccionario' puedes consultar CUALQUIER palabra en inglés. La Inteligencia Artificial te mostrará la traducción al español 🇪🇸, el significado en inglés 🇬🇧, ejemplos de uso en oraciones y párrafos, y un botón de audio 🔊 para escuchar la pronunciación en inglés nativo."
    },
    {
      q: "🎯 ¿Cómo me ayuda la plataforma para las Pruebas Estado ICFES / SABER?",
      a: "Cada unidad temática de 6°, 7° y 9° cuenta con un 'Examen de Entrenamiento ICFES' de 10 preguntas estandarizadas (Partes 1 a 6 del ICFES). Te dará tu puntaje de 0 a 100 puntos y te explicará la regla gramatical de cada pregunta."
    },
    {
      q: "🖨️ ¿Qué pasa si falla el internet en la sala de sistemas?",
      a: "¡Tranquilo! La plataforma cuenta con el modo offline. El Profesor Didier puede generar e imprimir la 'Guía de Trabajo Presencial en PDF de 2 Páginas' con el resumen de la unidad y los 20 ejercicios para responder en papel."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-6 text-left">
      {/* Encabezado del Panel FAQ */}
      <div className="border-b border-slate-700 pb-4">
        <span className="text-xs font-bold text-blue-400 uppercase tracking-wider">
          Centro de Ayuda e Información EOH
        </span>
        <h2 className="text-2xl md:text-3xl font-extrabold text-white mt-1">
          💬 Preguntas Frecuentes (FAQ)
        </h2>
        <p className="text-slate-300 text-sm mt-1">
          Resuelve todas tus dudas sobre el acceso, los puntos XP, los talleres de 20 ejercicios, el diccionario y los exámenes ICFES.
        </p>
      </div>

      {/* Lista Acordeón Desplegable */}
      <div className="space-y-3">
        {faqs.map((faq, idx) => (
          <div 
            key={idx}
            className="bg-slate-900/90 border border-slate-800 rounded-2xl overflow-hidden transition shadow-lg"
          >
            <button
              onClick={() => toggleFAQ(idx)}
              className="w-full p-5 text-left flex justify-between items-center font-bold text-white text-sm md:text-base hover:bg-slate-800/60 transition gap-4"
            >
              <span>{faq.q}</span>
              <span className="text-blue-400 font-extrabold text-xl">
                {openIndex === idx ? '−' : '+'}
              </span>
            </button>

            {openIndex === idx && (
              <div className="px-5 pb-5 pt-2 text-slate-300 text-xs md:text-sm leading-relaxed border-t border-slate-800/60 bg-slate-950/60 whitespace-pre-line animate-fade-in">
                {faq.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQSection;